import { BrokenImage } from '@components/index';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ContainerRelationsShips = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PriorityArrow = styled.div`
  height: 24px;
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Icon = styled.div`
  height: 20px;
`;

export const Text = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #1b203a;
  padding-top: 2px;
`;

interface IStatus {
  background: string;
}

export const Status = styled.div<IStatus>`
  user-select: none;
  background: ${({ background }) => background};
  color: #fff;
  font-size: 12px;
  height: 24px;
  width: 86px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding-top: 2px;
`;

export const File = styled.div`
  height: 40px;
  background: #f5f7fb;
  border: 1px solid #e6e8f0;
  border-radius: 4px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  padding-top: 2px;
`;

export const FileTextDisabled = styled.div`
  font-size: 12px;
  color: #8f95b2;
  text-decoration-line: line-through;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const FileText = styled.div`
  font-size: 12px;
  color: #696f8c;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const DateContainer = styled.div`
  height: 22px;
  border: 1px solid #d8dae5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 0 8px;
  gap: 5px;
`;

export const DateIcon = styled.div`
  height: 24px;
`;

export const DateText = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #474d66;
  padding-top: 2px;
`;

export const DateTextDisabled = styled.div`
  font-weight: 500;
  font-size: 12px;
  text-decoration-line: line-through;
  color: #8f95b2;
  padding-top: 2px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TextContentDisabled = styled.div`
  background: #f5f7fb;
  border: 1px solid #e6e8f0;
  border-radius: 4px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  text-decoration-line: line-through;
  color: #8f95b2;
  width: 100%;
`;

export const TextContent = styled.div`
  background: #f5f7fb;
  border: 1px solid #e6e8f0;
  border-radius: 4px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  color: #1b203a;
  width: 100%;
`;

export const TextComment = styled.div`
  background: #f5f7fb;
  border: 1px solid #e6e8f0;
  border-radius: 4px;
  padding: 8px 12px;

  font-size: 12px;
  color: #696f8c;
  width: 100%;

  p,
  strong,
  em,
  u,
  a {
    font-size: 12px;
    color: #696f8c;
  }

  a {
    color: #1371fe;
  }

  strong {
    font-weight: 600;
  }

  em {
    font-style: italic;
  }

  p {
    margin-bottom: 0;
  }
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e6e8f0;
  border-radius: 4px;
  padding: 0 4px;
`;

export const LabelImage = styled(BrokenImage)`
  height: 16px;
  width: 16px;
  object-fit: cover;
  border-radius: 50%;
  box-sizing: content-box;
`;

export const Name = styled.div`
  color: #474d66;
  font-size: 12px;
  padding-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const NameDisabled = styled.div`
  color: #8f95b2;
  font-size: 12px;
  padding-top: 2px;
  text-decoration-line: line-through;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const ProductContainer = styled.div`
  height: 32px;
  width: 100%;
  background: #f5f7fb;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 0 4px;
  border: 1px solid #e6e8f0;
`;

export const ProductGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 12px;
`;

export const ProductCell = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ProductImage = styled(BrokenImage)`
  width: 24px;
  height: 24px;
  border: 1px solid #e6e8f0;
  border-radius: 2px;
  object-fit: cover;
`;

export const ProductText = styled.div`
  padding-top: 2px;
  font-weight: 400;
  font-size: 12px;
  color: #474d66;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const ProductTextDisabled = styled.div`
  text-decoration-line: line-through;
  padding-top: 2px;
  font-weight: 400;
  font-size: 12px;
  color: #8f95b2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Empty = styled.div`
  color: #c1c4d6;
  font-size: 12px;
  font-style: italic;
  padding-top: 2px;
`;
